<script setup lang="ts">
import type { Menu } from '~/types'

interface Props {
  menu: Menu.Model
}

const props = defineProps<Props>()

const { menu } = toRefs(props)

const { hasItems, menuItems } = useMenu(menu)
</script>

<template>
  <MenuList
    v-if="hasItems"
    :menu-items="menuItems"
    is-top-level
    class="menu-list"
  />
</template>
